import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { authActions, useAppDispatch, useAppSelector } from '@app.raytd.com/store'
import { subscribeDemoNotifications } from '@/realtime/subscribe-demo'

export function useDemoOnboardingRealtime() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const userId = useAppSelector(s => s.auth.user?.user?.id)
  const token = useAppSelector(s => s.auth.user?.token)

  useEffect(() => {
    if (!userId || !token) return

    const unsubscribe = subscribeDemoNotifications({
      userId,
      dispatch,
      onStarted: (e) => {
        toast.info(e.message)
        dispatch(authActions.updateOnboardingStatus({ status: 'pending' }))
      },
      onReady: (e) => {
        toast.success('Your demo workspace is ready.', {
          action: e.primaryReportId
            ? {
                label: 'Open report',
                onClick: () => navigate(`/reports/${e.primaryReportId}`),
              }
            : undefined,
        })
        dispatch(authActions.updateOnboardingStatus({ status: 'complete', reportId: e.primaryReportId }))
      },
      onFailed: (e) => {
        toast.error(`Demo setup failed: ${e.message}`)
        dispatch(authActions.updateOnboardingStatus({ status: 'idle' }))
      },
    })

    return () => unsubscribe()
  }, [userId, token, dispatch, navigate])
}

